<div class="admin-modal">
  <div class="modal-header">
    <h3 class="modal-title">
      {{ title }}
    </h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise = !minimise"></i>
      <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
    </div>
  </div>

  <div class="modal-body" [hidden]="minimise">
    <div class="form-row">
      <div class="col-md-12 input-group">
        <label for="settingName">Name</label>
        <input type="text" id="settingName" class="form-control"
               [(ngModel)]="name"
               placeholder="Enter the name of key" required>
      </div>
    </div>
    <div class="form-row">
      <div class="col-md-12 input-group">
        <label for="settingValue">Value</label>
        <input type="text" id="settingValue" class="form-control"
               [(ngModel)]="value"
               placeholder="Enter the value of above key">
      </div>
    </div>
  </div>

  <div class="modal-footer" [hidden]="minimise">
    <button class="btn btn-primary btn-sm" type="button"
            (click)="saveSettings()"
            [disabled]="!name || loading">
      Save Setting
      @if (loading) {
<i class="fa fa-spinner fa-spin"></i>
}
    </button>
    <button class="btn btn-info btn-sm" type="button" (click)="cancel()">Cancel</button>
  </div>
</div>
